<template>
  <div>
    <ContactUserForm ref="contactFormRef" v-model="localValue" :disabled="false" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, type PropType } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module";
import ContactUserForm from "./forms/ContactUserForm.vue";
import type { ContactUserFormData } from "@/_helpers/ticket-helpers.ts";

export interface ContactUserDialogItem {
  includeEventDetails: boolean;
  contactMessage: string;
  recipients: string[];
  id: string;
  isDeviceEvent?: boolean;
}

export default defineComponent({
  components: {
    ContactUserForm,
  },
  props: {
    config: {
      type: Object as PropType<DialogDataConfig<ContactUserDialogItem>>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const contactFormRef = ref();

    const localValue = ref<ContactUserFormData>({
      includeEventDetails: true,
      contactMessage: "",
      recipients: (props.config.item.isDeviceEvent
        ? props.config.item.recipients.slice(0, 1)
        : props.config.item.recipients) as string[],
    });

    watch(
      localValue,
      (newValue) => {
        emit("update:localValue", {
          ...props.config,
          item: {
            ...props.config.item,
            ...newValue,
          },
        });
      },
      { deep: true }
    );

    const validate = async () => {
      const validationResult = await contactFormRef.value?.validate();
      return validationResult.valid;
    };

    return {
      contactFormRef,
      localValue,
      validate,
    };
  },
});
</script>
